<template>
  <div>
    <SideMenu />
    <div class="AppContent AppContentWidth container-fluid">
      <router-view v-slot="{ Component }">
        <transition>
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>

</template>

<script>
  import SideMenu from './components/SideMenu.vue'

  export default {
    name: 'App',
    components: {
      SideMenu
    }
  }
</script>

<style>
  #app {
    font-family: 'Roboto Mono';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-top: 60px;
    display: flex;
    width: 100%;
    color: black;
  }

  @media (min-width: 768px) {
    .AppContentWidth {
      width: calc(100% - 15rem);
    }
  }

  @media (max-width: 767px) {
    .AppContentWidth {
      width: 100%;
    }
  }

  .AppContent {
    height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
  }

  .v-enter-active {
    transition: opacity 0.8s ease-in;
  }
  .v-leave-active {
    transition: opacity 0.1s ease-out;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

</style>